import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './plugins/vuex';
import AppConfig from '@/commons/app_config';
import '@/assets/fonts/iconfont/iconfont.css';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
Object.defineProperties(Vue.prototype, {
  AppConfig: {
    get() {
      return AppConfig;
    }
  }
});
Vue.use(PerfectScrollbar);

Vue.config.productionTip = false;
import ViewUI from 'view-design';

import '@/assets/theme/index.less';

Vue.use(ViewUI, {
  i18n: function (path, options) {
    let value = i18n.t(path, options);
    if (value !== null && value !== undefined) {
      return value;
    }
    return '';
  }
});

import main_api_axios from '@/plugins/axios/main_api_axios';
Vue.prototype.$http = main_api_axios;

//時間序列化全局
import moment from 'moment-timezone';
Vue.prototype.$moment = moment;

import _ from 'lodash';
Vue.prototype.$_ = _;

/**
 * I18N 插件
 */
import { localeValueToKeyMap } from '@/assets/js/multilingual-tools';
import VueI18n from 'vue-i18n';
const initI18nMessages = () => {
  const locales = require.context(
    './static/i18n',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const keyName = matched[1];
      messages[keyName] = locales(key);
    }
  });
  return messages;
};
Vue.use(VueI18n);
Vue.locale = () => {};
const localeI18n = localStorage.getItem('i18n');
const defaultI18n = process.env.VUE_APP_REGION === 'yoov' ? 'hk' : 'cn';
const navigatorLocale = localeValueToKeyMap[navigator.language];
const locale = localeI18n
  ? localeI18n
  : navigatorLocale
  ? navigatorLocale
  : defaultI18n;
localStorage.setItem('i18n', locale);
const i18n = new VueI18n({
  locale: locale,
  messages: initI18nMessages()
});

router.beforeEach(async (to, _from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = i18n.t(to.meta.title);
  } else {
    document.title = i18n.t('global.selfservice');
  }
  next();
});

Vue.prototype.$substrName = function (str) {
  const pattern = new RegExp('[A-Za-z]+');
  if (pattern.test(str)) {
    const codeArr = str.split(' ');
    let firstCode = '';
    if (codeArr.length >= 1) {
      _.forEach(codeArr, (v, i) => {
        if (i < 2) {
          firstCode += _.toUpper(v.substr(0, 1));
        } else {
          return;
        }
      });
      str = firstCode;
    } else {
      str = _.toUpper(str.substr(0, 1));
    }
  } else {
    str = str.length === 3 ? str.substr(1, 2) : str.substr(0, 2);
  }
  return str;
};

//電話效驗
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
Vue.prototype.$parsePhoneNumberFromString = function (phone, code) {
  const phoneNumber = parsePhoneNumberFromString(`Phone: ${code}-${phone}`);
  return phoneNumber ? phoneNumber.isValid() : false;
};

Vue.prototype.$setEexlFileName = (blob, fileName) => {
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    window.navigator.msSaveBlob(blob, fileName);
  } else {
    let URL = window.URL || window.webkitURL;
    let objectUrl = URL.createObjectURL(blob);
    if (fileName) {
      let a = document.createElement('a');
      if (typeof a.download === 'undefined') {
        window.location = objectUrl;
      } else {
        a.href = objectUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(objectUrl);
        document.body.removeChild(a);
      }
    } else {
      window.location = objectUrl;
    }
    URL.revokeObjectURL(objectUrl);
  }
};

//刷新存儲state
window.addEventListener('beforeunload', () => {
  const states = JSON.stringify(store.state);
  localStorage.setItem('state', states);
});

import getQueryVariable from './assets/js/getQuery';
//获取oa后台传递的teamId数据
const teamId = getQueryVariable('teamId') || getQueryVariable('tenant');
if (teamId) {
  window.localStorage.setItem('teamId', teamId);
}

// 前端异常监控工具sentry
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
if (process.env.VUE_APP_ENV === 'production') {
  Sentry.init({
    Vue,
    // new here
    dsn: 'https://55c95fcb1a994b3ba3515422df12900d@o4504822439936000.ingest.sentry.io/4504954811580416',
    environment: 'production', //用于识别问题所在环境
    debug: false, // 开启后会在本地打印日志，生产环境下需关闭
    tracesSampleRate: 1.0, // 上报频率，1.0代表100%跟踪，0。1代表只跟踪10%
    // Called for message and error events
    beforeSend(event) {
      // Modify or drop the event here
      if (event.user) {
        // Don't send user's email address
        delete event.user.email;
      }
      return event;
    },
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracePropagationTargets: ['localhost', /^\//, '.*'] // 跟踪名单
      })
    ]
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
  });
}

// Auth
import AuthFn from '@/plugins/auth';
import { AuthManage } from './plugins/auth';
const AuthConfig = {
  init: {
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri:
      window.location.origin + '/silent-check-sso.html',
    enableLogging: true,
    checkLoginIframe: false //防止登陆后重复刷新
  },
  config: {
    url: AppConfig.oidc.configUrl,
    clientId: AppConfig.oidc.clientId,
    realm: AppConfig.oidc.realm
  },
  onReady(keycloak) {
    keycloak.onAuthLogout = function () {
      AuthManage.login();
    };
    window.VM = new Vue({
      router,
      store,
      i18n,
      render: (h) => h(App)
    }).$mount('#app');
  }
};
Vue.use(AuthFn, AuthConfig);
